document.addEventListener('click', async (event) => {
  const instagramShareLink = event.target.closest('.js-instagram-product-share');
  if (!instagramShareLink) return;

  const shareUrl = instagramShareLink.dataset.shareUrl;
  if (!shareUrl || !navigator.clipboard) return;

  try {
    await navigator.clipboard.writeText(shareUrl);
  } catch (error) {
    console.warn('Failed to copy product URL for Instagram share', error);
  }
});

document.addEventListener('submit', (event) => {
  const recommendationForm = event.target.closest('.you-might-also-like__form, .cart-drawer-ymal__form');
  if (!recommendationForm) return;

  const addButton = recommendationForm.querySelector('[data-ymal-add-button]');
  if (!addButton || addButton.hasAttribute('disabled')) return;

  addButton.dataset.ymalPending = 'true';
});

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (!event || event.source !== 'product-form') return;

    const variantId = String(event.productVariantId || event.variantId || '');
    if (!variantId) return;

    const addButtons = document.querySelectorAll(
      `[data-ymal-add-button][data-variant-id="${variantId}"][data-ymal-pending="true"]`
    );

    addButtons.forEach((button) => {
      button.classList.add('is-added');
      button.dataset.ymalPending = 'false';
    });
  });
}
